import React from 'react';
import { AccordionDetails } from '@mui/material';

const DSAccordionDetails = (
  props: React.ComponentProps<typeof AccordionDetails>,
) => {
  return (
    <AccordionDetails
      {...props}
      sx={{
        backgroundColor: 'transparent',
        borderRadius: 0,
        ...props.sx,
      }}
    />
  );
};

export default DSAccordionDetails;
